/**
 * i4 catalogue parity: prefer lots.lot_anim_name over animals.anim_name.
 * Internet Solutions / i4 list SQL uses COALESCE(lo.lot_anim_name, an.anim_name).
 */
export function resolveSaleLotDisplayName(
  lotAnimalName?: string | null,
  animalName?: string | null,
): string {
  const lotName = lotAnimalName?.trim() ?? '';
  if (lotName) return lotName;
  return animalName?.trim() ?? '';
}

/** i4 hides DLOT synthetic idents on catalogue lists (formatAnimalList.pas). */
export function sanitizeSaleLotIdent(ident?: string | null): string {
  const trimmed = ident?.trim() ?? '';
  if (!trimmed) return '';
  if (trimmed.toUpperCase().startsWith('DLOT')) return '';
  return trimmed;
}

/** Stable DataGrid row id for sale lots, including no-ident / DLOT rows. */
export function resolveSaleLotRowId(row: {
  saleId?: number | null;
  LOT_NO?: string | null;
  LOT_ANIMAL_ID?: string | number | null;
  ID?: number | null;
  ANIMAL_IDENT?: string | null;
}): string {
  if (row.saleId != null && row.LOT_NO) {
    return `${row.saleId}-${row.LOT_NO}`;
  }
  if (row.LOT_ANIMAL_ID != null && row.LOT_ANIMAL_ID !== '') {
    return String(row.LOT_ANIMAL_ID);
  }
  if (row.ID) {
    return String(row.ID);
  }
  return `${row.LOT_NO ?? ''}-${row.ANIMAL_IDENT ?? ''}`;
}
